import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { login, reset } from '../.././../../Redux/Features/Auth/authSlice';
import { useNavigate } from "react-router-dom";

import EmailInput from "../../../Partials/Layouts/Forms/FormInputs/EmailInput/EmailInput";
import PasswordInput from "../../../Partials/Layouts/Forms/FormInputs/PasswordInput/PasswordInput";
import AuthScreenWrapper from "../AuthScreenWrapper/AuthScreenWrapper";
import FormSubmitButton from "../../../Partials/Layouts/Forms/FormSubmitButton/FormSubmitButton";
import Form from "../../../Partials/Layouts/Forms/Form";
import { Helmet } from "react-helmet";

function Login() {

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const {isLoading, customer, isError, isSuccess, message} = useSelector((state) => state.auth)
  
  useEffect(() => {
    if(isError) {
        console.log(message)
    }
    if(isSuccess && customer) {
        customer.isVerified ? navigate('/') : navigate('/verify-email/default')
    }
    dispatch(reset())
  }, [customer, isError, isSuccess, message, navigate, dispatch])

  function handleSubmit(e) {

    e.preventDefault()

    const customerData = {
        email,
        password
    }

    dispatch(login(customerData))

  }

  if (isLoading) {
    return <h1>Loading...</h1>
  }

  return (
    <>
      <Helmet>
          <title>Login | Antcommerce Clothing</title>
      </Helmet>
      <AuthScreenWrapper
          heading={'Login'}
          linkOne={'/recover-pass-one'}
          textOne={'Forgot Password'}
          helperTextTwo={"Don't have an account?"}
          textTwo={'Sign Up'}
          linkTwo={'/signup'}
      >
          <Form onSubmit={handleSubmit}>
          
              <EmailInput 
                  label={'Email'}
                  inputName={email}
                  placeholder={'Please enter your Email'}
                  setState={setEmail}
              />

              <PasswordInput
                  label={'Password'}
                  inputName={password}
                  placeholder={'Please enter your Password'}
                  setState={setPassword}
              />

              <FormSubmitButton text={'Login'} />

          </Form>

      </AuthScreenWrapper>
    </>
  )
}

export default Login